import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'ws-truncated-text',
  templateUrl: './ws-truncated-text.component.html',
  styleUrls: ['./ws-truncated-text.component.scss'],
})
export class WsTruncatedTextComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('textRef') textRef!: ElementRef<HTMLElement>;

  @Input() text: string | null | undefined = '';
  @Input() maxLength: number | null = 27;

  tooltipValue: string | null = null;
  displayText = '';

  private resizeObserver: { disconnect(): void; observe(target: Element): void } | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.refreshTooltip();
    this.observeResize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text'] || changes['maxLength']) {
      this.refreshTooltip();
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.refreshTooltip();
  }

  private observeResize(): void {
    const ResizeObserverCtor = (window as any).ResizeObserver as
      | (new (callback: () => void) => { disconnect(): void; observe(target: Element): void })
      | undefined;

    if (!ResizeObserverCtor || !this.textRef?.nativeElement) {
      return;
    }

    this.resizeObserver = new ResizeObserverCtor(() => this.refreshTooltip());
    this.resizeObserver.observe(this.textRef.nativeElement);
  }

  private refreshTooltip(): void {
    requestAnimationFrame(() => {
      const el = this.textRef?.nativeElement;
      const value = (this.text ?? '').toString();

      if (!el || !value) {
        this.displayText = '';
        this.tooltipValue = null;
        this.cdr.markForCheck();
        return;
      }

      if (this.maxLength != null && this.maxLength > 0) {
        this.displayText =
          value.length > this.maxLength ? `${value.slice(0, this.maxLength)}...` : value;
        this.tooltipValue = value.length > this.maxLength ? value : null;
        this.cdr.markForCheck();
        return;
      }

      this.displayText = value;
      this.tooltipValue = el.scrollWidth > el.clientWidth ? value : null;
      this.cdr.markForCheck();
    });
  }
}
